// --- Our Modules --------------------------------------------------------------------------------
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./row.css";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { value: string | number; label: string; icon?: TyIconName };

/** The figure tiles across the top of a screen. Presentational — the screen counts, this shows. */
export default function StatCard({ value, label, icon = "stat" }: Props) {
    return (
        <article className="stat-card">
            <span className="stat-card__icon">
                <Icon name={icon} size={22} />
            </span>
            <div className="stat-card__text">
                <strong className="stat-card__value">{value}</strong>
                <span className="stat-card__label">{label}</span>
            </div>
        </article>
    );
}
